function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.75186,
  cy: 17.76,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.4862,
  cy: 15.7522,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.1859,
  cy: 24.4612,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 34.6024,
  cy: 18.096,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 47.3432,
  cy: 16.0862,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.44571,
  cy: 11.3967,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.1801,
  cy: 9.38503,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.8803,
  cy: 18.096,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 39.2963,
  cy: 11.7307,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 52.037,
  cy: 9.72096,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.4691,
  cy: 4.69557,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.204,
  cy: 2.68581,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.9032,
  cy: 11.3967,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 43.3197,
  cy: 5.03151,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 56.0605,
  cy: 3.02174,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 62.766,
  cy: 3.02174,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#CE1126"
});
function SvgMexicoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 27,
    viewBox: "0 0 65 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexicoRed);
export default __webpack_public_path__ + "static/media/mexico_red.a08a9f836b3725c1663e46aaf9f5cdcd.svg";
export { ForwardRef as ReactComponent };